import { Component, OnInit } from '@angular/core';
import { HelpPdfComponent } from '../help-pdf/help-pdf.component';
import { NavigationService } from '../services/navigation.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(
    private navService: NavigationService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
  }

  showHelpDialog() {
    // oepn the help dialog
    let data = {
      helpPage:''
    }

    let dialogRef = this.dialog.open(HelpPdfComponent, {
      height: '700px',
      width: '1010px',
      data: data
    });

    dialogRef.afterClosed().subscribe(result => {
      // all the same to me
    })  
  }

}
